export abstract class BaseModel {
  protected beforeToJSON(): void | Promise<void> {}

  protected getJsonFields(): string[] | null {
    return null
  }

  protected getJsonValue(key: string, value: any): any {
    return value
  }

  toJSON(icon?: Blob | File | string, seen: WeakSet<object> = new WeakSet(), path: string[] = []): Record<string, any> {
    seen.add(this)

    this.beforeToJSON()

    const json: Record<string, any> = {}
    const isJsonStringifyCall = typeof icon === "string"
    const jsonFields = isJsonStringifyCall ? null : this.getJsonFields()
    const keys = jsonFields ?? Object.keys(this)
    const childIcon = isJsonStringifyCall ? "" : undefined

    keys.forEach((key) => {
      const rawValue = (this as any)[key]
      const value = isJsonStringifyCall ? rawValue : this.getJsonValue(key, rawValue)
      const currentPath = [...path, key]

      if (value instanceof BaseModel) {
        json[key] = value.toJSON(childIcon, seen, currentPath)
      } else if (Array.isArray(value)) {
        json[key] = value.map((v, i) =>
          v instanceof BaseModel ? v.toJSON(childIcon, seen, [...currentPath, `[${i}]`]) : v,
        )
      } else {
        json[key] = value
      }
    })

    if (icon instanceof Blob && path.length === 0) {
      json["Icon"] = icon
    }

    return json
  }
}
